import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import PaymentWrapper from './Payment.style';
import Checkout from './Checkout';
//import PaymentDebit from './PaymentDebit';
import PaymentCredit from './PaymentCredit';
import PaymentMessage from './PaymentMessage';

import { paymentConfig } from '../../../ecosystem.config';
import { 
  setInnerPagesList, 
  setPaymentValue,
  cleanInstallments
} from '../../../actions';

class Payment extends Component {

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { 
      setInnerPagesList,
      cleanInstallments,
      initPaymentTypeSelected
    } = this.props;

    setInnerPagesList([
      { name: 'checkout',        back: '' },
      /*{ name: 'paymentDebit',    back: 'checkout' },*/
      { name: 'paymentMessage',  back: '', backButton: false }
    ]);

    cleanInstallments();
    
    let { quoter, config } = this.props;
    if (quoter && quoter !== '') config = quoter;
    const configValue = paymentConfig[config];

         if(configValue.red)    initPaymentTypeSelected('red');
    else if(configValue.debit)  initPaymentTypeSelected('debit');
    else if(configValue.visa)   initPaymentTypeSelected('credit');
    else if(configValue.master) initPaymentTypeSelected('credit');
    else if(configValue.oca)    initPaymentTypeSelected('credit');
  }

  page() {
    const { 
      stepInnerPage,
      quoterData,
      currency
    } = this.props;

    switch (stepInnerPage.name) {
      case 'checkout':
        return <Checkout currency={currency} quoterData={quoterData} />;
      //case 'paymentDebit':
      //  return <PaymentDebit handlePayment={handleDebit}/>;
      case 'paymentMessage':
        return <PaymentMessage/>;
    };
    return <div/>;
  }

  render() {
    
    const { 
      openSiemprePago, 
      quoterData,
      currency
    } = this.props;

    return (
      <PaymentWrapper>
        <form id="payment_form">
          <input type="hidden" name="PWToken" id="PWToken" />
        </form>
        {openSiemprePago && 
          <PaymentCredit 
            quoterData={quoterData}
            currency={currency}
          />
        }
        {this.page()}
      </PaymentWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    stepInnerPage: state.steps.stepInnerPage,
    quoter: state.options.quoter,
    openSiemprePago: state.payment.openSiemprePago
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setInnerPagesList: (page) => {
      dispatch(setInnerPagesList(page));
    },
    initPaymentTypeSelected: (name) => {
      dispatch(setPaymentValue('paymentType', name));
    },
    cleanInstallments: () => {
      dispatch(cleanInstallments());
    }
  };
};

Payment.propTypes = {
  // TODO: change object for shape
  // eslint-disable-next-line react/forbid-prop-types
  quoterData: PropTypes.object.isRequired,
  currency: PropTypes.string.isRequired,
  config: PropTypes.string.isRequired,
}

Payment.defaultProps = {
  config: 'Default',
  currency: 'UYU'
}

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
